import { RdkDatePickerComponent } from './rdk-date-picker';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    RdkDatePickerComponent,
  ],
  imports: [
    TranslateModule.forChild(),
    IonicPageModule.forChild(RdkDatePickerComponent),
  ],
  exports: [
    RdkDatePickerComponent
  ]
})
export class RdkDatePickerComponentModule {}
 


// WEBPACK FOOTER //
// ./src/components/rdk-date-picker/rdk-date-picker.module.ts